import { default as HomePage } from "../components/Home";

const Home = () => {
  return <HomePage />;
};

export default Home;
